module.exports = __webpack_public_path__ + "img/icon1.c68a1ac0.jpg";